/**
 * useAttendance — React Query hook havi jelenlét lekérdezéséhez
 *
 * 106-2c HOTFIX: a backend `{ records, summary }` shape — records-ot adja vissza a hook,
 * a summary-t külön hook teszi elérhetővé (useAttendanceSummary).
 */

import { useQuery } from '@tanstack/react-query';
import {
  getMonthlyAttendance,
  type AttendanceRecord,
  type MonthlyAttendanceReport,
} from '../api/hr-api';

export function attendanceQueryKey(year: number, month: number) {
  return ['hr', 'attendance', year, month] as const;
}

export function useAttendance(year: number, month: number) {
  return useQuery<AttendanceRecord[]>({
    queryKey: attendanceQueryKey(year, month),
    queryFn: async () => {
      const res = await getMonthlyAttendance(year, month);
      // HOTFIX 106-2c: backend { records, summary } shape, records a valódi array
      return res.data.records ?? [];
    },
    staleTime: 30_000,
  });
}

export function useAttendanceSummary(year: number, month: number) {
  return useQuery<MonthlyAttendanceReport['summary']>({
    queryKey: [...attendanceQueryKey(year, month), 'summary'],
    queryFn: async () => {
      const res = await getMonthlyAttendance(year, month);
      return res.data.summary;
    },
    staleTime: 30_000,
  });
}
